
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M24 0H0v16h24V0z","fill":"#F0F0F0"}}),_c('path',{attrs:{"d":"M24 0H0v5.333h24V0z","fill":"#FF9811"}}),_c('path',{attrs:{"d":"M24 10.667H0V16h24v-5.333z","fill":"#6DA544"}}),_c('path',{attrs:{"d":"M12 10.058a2.058 2.058 0 100-4.116 2.058 2.058 0 000 4.116z","fill":"#0052B4"}}),_c('path',{attrs:{"d":"M12 9.286a1.286 1.286 0 100-2.572 1.286 1.286 0 000 2.572z","fill":"#F0F0F0"}}),_c('path',{attrs:{"d":"M12 6.413l.397.9.977-.106-.58.793.58.793-.977-.106-.397.9-.397-.9-.977.106.58-.793-.58-.793.977.106.397-.9z","fill":"#0052B4"}})])
          )
        }
      }
    